// IMPORTS ****************************************************************************************
// ************************************************************************************************
import {
  ApiSpokenLanguageLevels,
  ApiBenefitsList,
  ApiBenefitsListOk,
  ApiSpokenLanguageLevelsObj,
  ApiSpokenLanguages,
  ApiSpokenLanguagesObj,
  ApiSelfInterviewQuestions,
  ApiGetSalaryCurrencies,
  ApiGetSalaryCurrenciesOk,
  ApiGetStudyLevels,
  ApiGetStudyLevelsOk,
  ApiGetDrivingSkills,
  ApiGetDrivingSkillsOk,
  ApiGetSpokenLanguageLevelsOk,
  ApiGetSpokenLanguageLevels,
  ApiGetPhoneCountries,
  ApiGetPhoneCountriesOk,
  ApiGetSelfInterviewQuestionOk,
} from 'src/types/v1-api-types';


// BENEFITS *******************************************************************************
// pathname: /v1/static-lists/benefits
// ****************************************************************************************
// benefits response OK
export const isBenefitsListOk = (res: ApiBenefitsList | void): res is ApiBenefitsListOk => {
  if ((res as ApiBenefitsListOk).length > 0) {
    return (res as ApiBenefitsListOk)[0]?.name !== undefined;
  }
  return false;
};

// Spoken languages ************************************************************************************
// pathname: /v1/static-lists/spoken-languages
// ************************************************************************************************
export const isSpokenLanguagesOk = (res: ApiSpokenLanguages | void): res is ApiSpokenLanguagesObj => res !== undefined && res !== null
  && Object.keys(res)?.length > 0;


// Spoken language levels ************************************************************************************
// pathname: /v1/static-lists/spoken-language-levels
// ************************************************************************************************
export const isSpokenLanguageLevelsOk = (res: ApiGetSpokenLanguageLevels | void)
: res is ApiGetSpokenLanguageLevelsOk => res !== undefined && res !== null
  && Object.keys(res)?.length > 0;

export const isSpokenLanguageLevelsObjectOk = (res: ApiSpokenLanguageLevels | void)
: res is ApiSpokenLanguageLevelsObj => res !== undefined && res !== null
  && (res as ApiSpokenLanguageLevelsObj)?.length > 0;


// Get driving skills ************************************************************************************
// pathname: /v1/resume/driving-skills
// ************************************************************************************************
export const isGetDrivingSkillsOk = (res: ApiGetDrivingSkills | void): res is ApiGetDrivingSkillsOk => res !== undefined && res !== null
  && (res as ApiGetDrivingSkillsOk)?.licenceCatB !== undefined;


// Self interview questions ***********************************************************************
// pathname: /v1/static-lists/self-interview-questions
// ************************************************************************************************
export const isSelfInterviewQuestionsOk = (res: ApiSelfInterviewQuestions | void): res is ApiGetSelfInterviewQuestionOk[] => res !== undefined && res !== null
  && (res as ApiGetSelfInterviewQuestionOk[])?.length !== undefined;

// Salary currencies ************************************************************************************
// pathname: /v1/static-lists/salary-currencies
// ************************************************************************************************
export const isSalaryCurrenciesOk = (res: ApiGetSalaryCurrencies | void): res is ApiGetSalaryCurrenciesOk => res !== undefined && res !== null
  && (res as ApiGetSalaryCurrenciesOk)?.length !== undefined;


// Study levels ************************************************************************************
// pathname: /v1/static-lists/study-levels
// ************************************************************************************************
export const isStudyLevelsOk = (res: ApiGetStudyLevels | void): res is ApiGetStudyLevelsOk => res !== undefined && res !== null
  && (res as ApiGetStudyLevelsOk)?.length > 0;


// Phone countries ************************************************************************************
// pathname: /v1/static-lists/phone-countries
// ************************************************************************************************
export const isPhoneCountriesOk = (res: ApiGetPhoneCountries | void): res is ApiGetPhoneCountriesOk => res !== undefined && res !== null
  && (res as ApiGetPhoneCountriesOk).length > 0;
